import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';
import { Section, InputField } from '../components';

const NUMBER_OF_STEPS = 100;
const MIN_SCORE_THRESHOLD = 0;

const RangeSlider = styled(Box)`
  max-width: 400px;
`;

function Config(props) {
  const {
    setConfig, saveConfig, isSaving, data,
  } = props;

  const { scoreThreshold } = data;

  const formattedScoreThreshold = Math.floor(scoreThreshold * (100 / NUMBER_OF_STEPS));

  const handleScoreThresholdChange = (e) => {
    setConfig({ scoreThreshold: parseInt(e.target.value, 10) });
  };

  const score = formattedScoreThreshold || MIN_SCORE_THRESHOLD;

  return (
    <Box>
      <Section
        title="Confidence threshold"
        subtitle="Set the confidence percentage to use for a bot suggestion. Only intents that match with a score higher than the threshold will be shown in the widget."
      >
        <RangeSlider>
          <InputField
            label={`${score}%`}
            labelPosition={score}
            isSaving={isSaving}
            name="score-threshold"
            id="scoreThresholdRangeInput"
            value={scoreThreshold || MIN_SCORE_THRESHOLD}
            handleChange={handleScoreThresholdChange}
            onMouseUp={saveConfig}
            inputType="inputRange"
            max={NUMBER_OF_STEPS}
            min={MIN_SCORE_THRESHOLD}
            isLast
            px={3}
          />
        </RangeSlider>
      </Section>
    </Box>
  );
}

Config.defaultProps = {};

Config.propTypes = {
  isSaving: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  setConfig: PropTypes.func.isRequired,
  saveConfig: PropTypes.func.isRequired,
};

export default Config;
